import { createSelector } from 'reselect';

const convertCollectionToSelector = items =>
  items.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

export const baseDirections = state => state.formCollections.directions;
export const baseEventTypes = state => state.formCollections.eventTypes;
export const baseGames = state => state.formCollections.game;
export const basePlatforms = state => state.formCollections.platform;
export const baseVersions = state => state.formCollections.versions;
export const baseResponsible = state => state.formCollections.responsible;
export const baseChannels = state => state.formCollections.channels;
export const baseClassTags = state => state.formCollections.classTags;
export const baseTechTags = state => state.formCollections.techTags;
export const baseTypeTags = state => state.formCollections.typeTags;

export const directions = createSelector(
  baseDirections,
  convertCollectionToSelector,
);

export const eventTypes = createSelector(
  baseEventTypes,
  convertCollectionToSelector,
);

export const game = createSelector(baseGames, convertCollectionToSelector);

export const responsible = createSelector(
  baseResponsible,
  convertCollectionToSelector,
);

export const platform = createSelector(
  basePlatforms,
  convertCollectionToSelector,
);

export const channels = createSelector(
  baseChannels,
  convertCollectionToSelector,
);

export const versions = createSelector(baseVersions, versions =>
  versions.map(version => version.id),
);

export const classTags = createSelector(
  baseClassTags,
  convertCollectionToSelector,
);

export const techTags = createSelector(
  baseTechTags,
  convertCollectionToSelector,
);

export const typeTags = createSelector(baseTypeTags, types =>
  types.map(type => type.id),
);
